var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"spinner spinner-origami",style:(_vm.styles)},[_c('div',{staticClass:"spinner-inner loading",style:(_vm.innerStyles)},[_c('span',{staticClass:"slice"}),_c('span',{staticClass:"slice"}),_c('span',{staticClass:"slice"}),_c('span',{staticClass:"slice"}),_c('span',{staticClass:"slice"}),_c('span',{staticClass:"slice"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }